const products = [
  {
    icon: "ri-temp-cold-line",
    title: "Split & Multi-Split AC Systems",
    desc: "Energy-efficient split and multi-split air conditioning units for offices, retail spaces, apartments and light commercial use. Supply, installation and commissioning included.",
    badge: "Most Popular",
    image: "/images/hvac/split-ac.webp",
  },
  {
    icon: "ri-building-4-line",
    title: "Central Air Handling Units (AHU)",
    desc: "Large-scale AHU systems for hotels, hospitals, shopping malls and industrial facilities. Custom-designed to handle precise airflow volumes and temperature control.",
    badge: "Commercial",
    image: "/images/hvac/ahu.webp",
  },
  {
    icon: "ri-settings-4-line",
    title: "Industrial Ductwork Fabrication",
    desc: "In-house fabricated galvanised steel and stainless steel ductwork cut and formed to any shape, size and specification for commercial and industrial HVAC systems.",
    badge: "In-House Made",
    image: "/images/hvac/ductwork.webp",
  },
  {
    icon: "ri-tornado-line",
    title: "Mechanical Ventilation Systems",
    desc: "Supply air, extract air, and heat recovery ventilation systems for kitchens, car parks, server rooms and laboratories requiring controlled air exchange.",
    badge: "Specialised",
    image: "/images/hvac/ventilation.webp",
  },
  {
    icon: "ri-hospital-line",
    title: "Precision Cooling for Data & Medical",
    desc: "High-precision cooling solutions for server rooms, data centres, operating theatres and pharmacy stores — maintaining critical temperature and humidity levels 24/7.",
    badge: "Critical Cooling",
    image: "/images/hvac/precision-cooling.webp",
  },
  {
    icon: "ri-cloud-windy-line",
    title: "Exhaust & Fresh Air Systems",
    desc: "Dedicated exhaust fans, louvre arrays, and fresh air intake systems for chemical stores, generator rooms, kitchens and spaces requiring constant air change rates.",
    badge: "Ventilation",
    image: "/images/hvac/exhaust.webp",
  },
];

export default function HvacProducts() {
  return (
    <section id="products" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-teal-600 text-xs font-semibold uppercase tracking-widest mb-3 block">What We Supply &amp; Install</span>
          <h2 className="text-gray-900 text-4xl md:text-5xl font-extrabold uppercase tracking-tight">
            Our HVAC Product Range
          </h2>
          <p className="text-gray-500 text-sm mt-4 max-w-xl mx-auto leading-relaxed">
            Every system is engineered to your exact site requirements — from a single office split unit to a full central HVAC infrastructure for a high-rise building.
          </p>
        </div>

        {/* Products grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((item, i) => (
            <div key={i} className="bg-white rounded-lg overflow-hidden border border-gray-100 hover:border-teal-200 transition-all duration-300 group">
              <div className="relative overflow-hidden h-52">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center bg-teal-600 rounded-lg">
                  <i className={`${item.icon} text-base text-white`}></i>
                </div>
                <span className="absolute top-4 right-4 bg-white/90 text-teal-700 text-xs font-bold px-2.5 py-1 rounded-full uppercase tracking-wider">
                  {item.badge}
                </span>
              </div>
              <div className="p-6">
                <h3 className="text-gray-900 font-bold text-sm uppercase tracking-wide mb-2">{item.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{item.desc}</p>
                <a
                  href="#inquiry"
                  onClick={(e) => { e.preventDefault(); document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" }); }}
                  className="mt-4 inline-flex items-center gap-1.5 text-teal-600 hover:text-teal-700 text-xs font-semibold uppercase tracking-wider cursor-pointer transition-colors"
                >
                  Enquire Now
                  <i className="ri-arrow-right-line text-sm"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* CTA strip */}
        <div className="mt-14 bg-teal-600 rounded-lg px-8 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-teal-100 text-xs uppercase tracking-widest font-semibold mb-1">Not sure what you need?</p>
            <h3 className="text-white text-2xl md:text-3xl font-extrabold">
              Our Engineers Will Design the Right System for You
            </h3>
          </div>
          <a
            href="#inquiry"
            onClick={(e) => { e.preventDefault(); document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" }); }}
            className="bg-white text-teal-700 hover:bg-teal-50 font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap"
          >
            Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
}
